/**
 * Alert action constants
 * Source of truth: backend/constants/alertActions.js
 * Keep in sync with mobile/app/constants/alerts.ts
 */
export const ALERT_ACTIONS = {
  // Budget actions
  REVIEW_BUDGET: 'reviewBudget',
  REVIEW_APPROVE_INITIAL_BUDGET: 'review_approve_initial_budget',
  REVIEW_BUDGET_CATEGORY: 'reviewBudgetCategory',
  ADJUST_BUDGET: 'adjust',
  ALLOCATE_FUNDS: 'allocate',
  COMPLETE_BUDGET_SETUP: 'completeBudgetSetup',

  // Transaction / AI actions
  REVIEW_LOW_CONFIDENCE: 'reviewLowConfidence',
  // Held family purchases. Web opens the family review modal. RN and native open the mixed deck.
  FAMILY_ASSIGNMENT_NEEDED: 'family_assignment_needed',
  CONFIRM_ACCOUNTS: 'confirmAccounts',

  // Premium
  UNLOCK_PREMIUM_TRIAL: 'unlockPremiumTrial',

  // Reimbursement
  REVIEW_REIMBURSEMENT_REQUEST: 'reviewReimbursementRequest',
  MATCH_REIMBURSEMENT_REQUEST: 'matchReimbursementRequest',

  // Bill actions
  REVIEW_BILL_MATCH: 'reviewBillMatch',
  REVIEW_RECURRING_STREAM: 'reviewRecurringStream',
  LINK_BILLS_TO_BUDGET: 'linkBillsToBudget',

  // Goal actions (v1.1 Phase 2+)
  LINK_GOAL_TO_BUDGET: 'linkGoalToBudget',
  UNFUNDED_GOAL: 'unfundedGoal',
  GOAL_ACHIEVED_OUTSIDE_BUDGET: 'goalAchievedOutsideBudget',
  EMERGENCY_FUND_TAPPED: 'emergencyFundTapped',
  REPLENISH_GOAL: 'replenishGoal',

  // Cash flow actions (v1.1 Phase 3b)
  CASH_CRUNCH: 'cashCrunch',
  PACE_MISMATCH: 'paceMismatch',
  OVERDRAFT_RISK: 'overdraftRisk',

  // Spending alerts (#223)
  BUDGET_VELOCITY: 'budgetVelocity',
  BUDGET_REBALANCE_RECOMMENDATION: 'budgetRebalanceRecommendation',
  DAILY_SPENDING_ANOMALY: 'dailySpendingAnomaly',
  /** @deprecated Removed from transaction ingestion pipeline (#223). Kept for backward compatibility. */
  DUPLICATE_TRANSACTION: 'duplicateTransaction',
  LARGE_TRANSACTION: 'largeTransaction',

  // Daily check-in (#225)
  DAILY_CHECK_IN: 'dailyCheckIn',

  // Period alerts (#225) — @deprecated Superseded by DAILY_CHECK_IN
  /** @deprecated Superseded by DAILY_CHECK_IN (#225) */
  WEEKEND_SPENDING: 'weekendSpending',
  /** @deprecated Superseded by DAILY_CHECK_IN (#225). onIncomeDetected still uses this. */
  PAYDAY_OPTIMIZATION: 'paydayOptimization',

  // AI pattern alerts (#224)
  MISCATEGORIZATION_PREVENTION: 'miscategorizationPrevention',
  RECURRING_PATTERN_DETECTED: 'recurringPatternDetected',
  SUBSCRIPTION_PRICE_INCREASE: 'subscriptionPriceIncrease',
};

// Helper array for budget navigation actions
export const BUDGET_NAVIGATION_ACTIONS = [
  ALERT_ACTIONS.ADJUST_BUDGET,
  ALERT_ACTIONS.ALLOCATE_FUNDS,
];
